export const enum MutationNames {
  updateSiteStatses = 'SITE_STATS_UPDATE_SITE_STATSES',
}

export const enum ActionNames {
  getSiteStatses = 'SITE_STATS_GET_SITE_STATSES',
}

export const enum GetterNames {
  siteStatses = 'SITE_STATS_SITE_STATSES',
}
